import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type { IbhCatalogArticleLifetimeParams } from '@igus/iglidur-bearing-hub-api';
import * as Sentry from '@sentry/nextjs';

export const fetchCatalogArticleLifeTime = async (
  ibhCatalogArticleLifetimeParams: IbhCatalogArticleLifetimeParams
): Promise<number> => {
  try {
    ibhApiService.abortRequest('catalogArticleLifetime');
    const response = await ibhApiService.catalogArticleLifetime(ibhCatalogArticleLifetimeParams, {
      cancelToken: 'catalogArticleLifetime',
    });
    return response.data.lifetime;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(
      `Cannot fetch catalog lifetime for article number: ${ibhCatalogArticleLifetimeParams.articleNumber}`
    );
  }
};
